import { partnerMockData } from "./mock/partnerData";

export const getDataByAll = (type = null) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      if (type) {
        const filteredData = partnerMockData.filter(item => item.type === type);
        resolve(filteredData);
      } else {
        resolve(partnerMockData);
      }
    }, 500);
  });
};